export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nombre:"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Guardar"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Atrás"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Por favor, proporcione un nuevo nombre para el activo"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Este nombre le ayudará a identificar la billetera más fácilmente en su lista de activos."])}
}